import BaseElement from './BaseElement'
import { WishlistSharedDisplay } from '../components/WishlistSharedDisplay'

export default class WishlistSharedDisplayElement extends BaseElement {
  renderElement() {
    const showDashboardPageTitle = this.getAttribute('show-dashboard-page-title') !== 'false'

    this.rootElement?.render(<WishlistSharedDisplay showDashboardPageTitle={showDashboardPageTitle} />)
  }
}
